var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "margin", attrs: { justify: "space-between" } },
        [
          _c(
            "el-col",
            [
              _c(
                "el-radio-group",
                {
                  attrs: { value: _vm.interessado.pessoa.tipo },
                  nativeOn: {
                    change: function($event) {
                      return _vm.clearDocumentos($event)
                    }
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "PF" } }, [
                    _vm._v("Pessoa Física")
                  ]),
                  _c("el-radio", { attrs: { label: "PJ" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.isProcessoFisico
                          ? "Pessoa Jurídica/Associação"
                          : "Pessoa Jurídica"
                      )
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.interessado.pessoa.tipo === "PF" &&
      _vm.hasEspolio &&
      !_vm.isLiberacao &&
      !_vm.isProcessoFisico
        ? _c(
            "el-row",
            [
              _c("validation-provider", {
                attrs: {
                  rules: _vm.interessado.pessoa.tipo === "PF" ? "required" : "",
                  name: "Interessado/Espólio"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            attrs: { label: "É espólio?", required: true }
                          }),
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "input checkbox-group",
                              class: { erro: errors[0] },
                              attrs: { name: "Espólio" },
                              model: {
                                value: _vm.interessado.espolio,
                                callback: function($$v) {
                                  _vm.$set(_vm.interessado, "espolio", $$v)
                                },
                                expression: "interessado.espolio"
                              }
                            },
                            [
                              _c(
                                "el-radio",
                                { attrs: { name: "espolio", label: true } },
                                [_vm._v("Sim")]
                              ),
                              _c(
                                "el-radio",
                                { attrs: { name: "espolio", label: false } },
                                [_vm._v("Não")]
                              )
                            ],
                            1
                          ),
                          _c("span", { staticClass: "help erro" }, [
                            _vm._v(_vm._s(errors[0]))
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  843809741
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm.interessado.pessoa.tipo === _vm.cadastrante.pessoa.tipo &&
      !_vm.isProcessoFisico
        ? _c(
            "el-row",
            { staticClass: "usar-dados-cadastrante" },
            [
              _c(
                "el-col",
                [
                  _c("el-checkbox", {
                    attrs: { label: "Usar dados do cadastrante" },
                    on: { change: _vm.usarDadosCadastrante }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.interessado.pessoa.tipo === "PF"
        ? _c("app-pessoa-fisica", {
            attrs: {
              pessoa: _vm.interessado.pessoa,
              conjuge: _vm.interessado.conjuge,
              nomeAba: "Interessado",
              observer: _vm.observer,
              isLiberacao: _vm.isLiberacao,
              isProcessoFisico: _vm.isProcessoFisico
            }
          })
        : _vm._e(),
      _vm.interessado.pessoa.tipo === "PJ" && !_vm.isProcessoFisico
        ? _c("app-pessoa-juridica", {
            attrs: {
              pessoa: _vm.interessado.pessoa,
              nomeAba: "Interessado",
              observer: _vm.observer
            }
          })
        : _vm._e(),
      _vm.interessado.pessoa.tipo === "PJ" && _vm.isProcessoFisico
        ? _c("app-pessoa-juridica-processo-fisico", {
            attrs: {
              pessoa: _vm.interessado.pessoa,
              nomeAba: "Interessado",
              observer: _vm.observer
            }
          })
        : _vm._e(),
      _vm.hasSocios &&
      _vm.interessado.pessoa.tipo === "PJ" &&
      !_vm.isProcessoFisico
        ? _c("app-socio", {
            attrs: {
              socios: _vm.interessado.socios
                ? _vm.interessado.socios
                : _vm.socios
            }
          })
        : _vm._e(),
      !_vm.isProcessoFisico
        ? _c("app-endereco", {
            attrs: {
              endereco: _vm.interessado.pessoa.endereco,
              nomeAba: "Interessado"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f740f8ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f740f8ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/cadastro/InteressadoSicarf.vue
// module id = null
// module chunks = 